import { gql } from "@apollo/client";

export const CREATE_RISK_SCORE_ADJUSTMENT = gql`
  mutation createRiskScoreAdjustment($input: CreateRiskScoreAdjustmentInput!) {
    aml {
      createRiskScoreAdjustment(input: $input) {
        success
      }
    }
  }
`;
